<template>
  <div class="p-4">
    <header class="mb-4">
      <h1 class="font-size-20 font-weight-700 text-neutral-grey-90 mt-0 mb-2">
        {{ $i18n('.titulo') }}
      </h1>
      <p class="text-cinza-5 m-0">
        {{ $i18n('.descricao') }}
      </p>
    </header>

    <ToursGuiadosAdminFiltro @filtrar="aoFiltrar" />

    <div v-if="carregando" class="p-5 text-center bg-cinza-1 rounded text-cinza-5" role="status">
      {{ $i18n('.carregando') }}
    </div>

    <div v-else-if="erroCarregamento" class="p-5 text-center bg-error-10 text-feedback-error-50 rounded" role="alert">
      <p class="mb-3">{{ erroCarregamento }}</p>
      <button type="button" class="btn btn-nd-secondary" @click="carregar">
        {{ $i18n('.tentar_novamente') }}
      </button>
    </div>

    <div v-else-if="listaVazia" class="p-5 text-center bg-cinza-1 rounded text-cinza-5">
      {{ temFiltroAtivo ? $i18n('.filtros.sem_resultados') : $i18n('.sem_tours') }}
    </div>

    <section v-else class="table-list-items table-responsive border border-cinza-3 rounded bg-white p-3">
      <table class="table table-striped table-hover custom-table-maino w-100 mb-0">
        <thead class="border-bottom border-cinza-2">
          <tr>
            <th scope="col" class="text-neutral-grey-90 font-weight-700 font-size-14">{{ $i18n('.colunas.nome') }}</th>
            <th scope="col" class="text-neutral-grey-90 font-weight-700 font-size-14">{{ $i18n('.colunas.rota') }}</th>
            <th scope="col" class="text-right text-neutral-grey-90 font-weight-700 font-size-14">{{ $i18n('.colunas.passos') }}</th>
            <th scope="col" class="text-right text-neutral-grey-90 font-weight-700 font-size-14">{{ $i18n('.colunas.concluidos') }}</th>
            <th scope="col" class="pl-4 text-neutral-grey-90 font-weight-700 font-size-14 text-center">{{ $i18n('.colunas.status') }}</th>
            <th scope="col" class="text-nowrap text-neutral-grey-90 font-weight-700 font-size-14">{{ $i18n('.colunas.acoes') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tour in tours" :key="tour.id">
            <td>{{ tour.nome }}</td>
            <td><code class="text-primary-30">{{ tour.rota_pattern }}</code></td>
            <td class="text-right">{{ tour.passos_count }}</td>
            <td class="text-right">{{ tour.concluidos_count }}</td>
            <td class="pl-4">
              <ToggleSwitch
                :model-value="tour.ativo"
                :disabled="processandoId === tour.id"
                @update:modelValue="confirmarToggle(tour)"
              />
            </td>
            <td class="text-nowrap">
              <a
                :href="tour.ativo ? `${URL_TOURS}/${tour.id}/edit` : undefined"
                class="btn btn-nd-primary btn-sm"
                :class="{ disabled: !tour.ativo }"
                :aria-disabled="!tour.ativo"
                :tabindex="tour.ativo ? undefined : -1"
              >
                {{ $i18n('.acoes.editar') }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import ToggleSwitch from '~/src/shared/ToggleSwitch.vue'
import ToursGuiadosAdminFiltro from './ToursGuiadosAdminFiltro.vue'
import mixinTourGuiadoAdmin from './mixinTourGuiadoAdmin'

export default {
  name: 'ToursGuiadosAdminIndex',
  components: { ToggleSwitch, ToursGuiadosAdminFiltro },
  mixins: [mixinTourGuiadoAdmin],
  data() {
    return {
      tours: [],
      processandoId: null,
      filtrosAtuais: {
        nome: '',
        rotaPattern: '',
        ativo: '',
      },
    }
  },
  computed: {
    listaVazia() {
      return this.tours.length === 0
    },
    temFiltroAtivo() {
      return this.filtrosAtuais.nome.trim() !== ''
        || this.filtrosAtuais.rotaPattern.trim() !== ''
        || this.filtrosAtuais.ativo !== ''
    },
  },
  methods: {
    aoFiltrar(filtros) {
      this.filtrosAtuais = { ...filtros }
      this.carregar()
    },
    montarParametros() {
      const parametros = new URLSearchParams()
      const nome = this.filtrosAtuais.nome.trim()
      const rotaPattern = this.filtrosAtuais.rotaPattern.trim()
      if (nome) parametros.append('nome', nome)
      if (rotaPattern) parametros.append('rota_pattern', rotaPattern)
      if (this.filtrosAtuais.ativo) parametros.append('ativo', this.filtrosAtuais.ativo)
      const query = parametros.toString()
      return query ? `?${query}` : ''
    },
    carregar() {
      this.carregarRecurso({
        url: `${this.URL_TOURS}.json${this.montarParametros()}`,
        chaveErro: 'erros.carregar',
        onSuccess: (dados) => {
          this.tours = Array.isArray(dados) ? dados : []
        },
      })
    },
    confirmarToggle(tour) {
      const acao = this.$i18n(tour.ativo ? '.acoes.inativar' : '.acoes.ativar')
      const titulo = this.$i18n('.toggle.titulo', { acao })
      const mensagem = this.$i18n(tour.ativo ? '.toggle.confirmar_inativacao' : '.toggle.confirmar_reativacao')

      mainoAlert({
        htmlContent: `
          <div class="text-cinza-texto">
            <div class="text-center mb-3">
              <i class="fa fa-exclamation-circle text-feedback-alert-40" style="font-size: 64px;"></i>
            </div>
            <p class="font-size-20 font-weight-700 text-center">${titulo}</p>
            <p>${mensagem}</p>
          </div>
        `,
        confirmText: acao,
        cancelText: this.$i18n('.toggle.cancelar'),
        buttonClose: true,
        modalWidth: '424px',
        bodyClasses: 'mt-6 text-center',
        buttonsWrapperClasses: 'mt-6 mb-6',
        showHeader: false,
      }).then(() => this.alternarStatus(tour)).catch(() => {})
    },
    alternarStatus(tour) {
      this.processandoId = tour.id
      this.$api.patch(`${this.URL_TOURS}/${tour.id}/toggle_ativo`)
        .then(({ data }) => {
          exibe_mensagem_com_status(data.mensagem || this.$i18n('.notificacao.atualizacao_padrao'), 'success')
          if (this.filtrosAtuais.ativo !== '') {
            this.carregar()
            return
          }
          const indice = this.tours.findIndex((t) => t.id === tour.id)
          if (indice >= 0) this.tours[indice] = { ...this.tours[indice], ativo: data.ativo }
        })
        .catch((erro) => {
          const mensagem = erro?.response?.data?.erro || this.$i18n('.erros.inesperado_alterar')
          exibe_mensagem_com_status(mensagem, 'error')
        })
        .finally(() => {
          this.processandoId = null
        })
    },
  },
}
</script>
